module.exports = function getResource(label, vars = []) {
    const resources = {
        add: 'Ajouter',
        addMessage: 'Ajouter une carte-cadeau Sephora',
        addSubMessage: 'Le cadeau simple et idéal dont tout le monde rêve'
    };

    return resources[label];
};
